

<template>

<v-container v-if="article">
  <v-row style="background-color: #244139">
    <v-col class="d-none d-md-block">
    </v-col>
    <v-col md="4" cols="12">
      <div :style="getDivStylePrincipal(article.link)">
      </div>
    </v-col>
    <v-col class="d-none d-md-block">
    </v-col>
    <v-col cols="12" md="6">
      <div class="text-center">
        <p class="title-article-see">{{ article.title }}</p>
      <p style="font-family: Noto Sans;
font-size: 25px;
font-weight: 400;
line-height: 34px;
letter-spacing: 0em;
text-align: center;
 color:white" >{{article.resumen}}</p>
      </div>

    </v-col>
      </v-row>
  <v-row>
    <v-col cols="10" offset-md="1">
      <div v-html="article.contentHtml" class="ck-content"></div>
    </v-col>
  </v-row>
</v-container>

</template>
<script>


import gql from "graphql-tag";
export default {
  apollo: {
    article: {query: gql` query($id:String!){
       article(id:$id){
        id
        title
        resumen
        contentHtml
        link:linkPhoto
      }
    }`,
      variables() {return {"id" :this.id}}
    },
  },
  props:['id'],
    name:"SeeArticleChess",
  data() {
    return {
      article: null,
    }
  },
  components: {

  },
  computed:{
    info_t(){
      return JSON.parse(this.tournament.content)
    }
  },
  methods: {
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    getDivStylePrincipal(link) {
      return {
    'height': '300px',
    'background-image': `url(${link})`,
    'background-size': '100% 100%',  // cambio aquí
    'background-position': 'center',
      };
    },
  },
}
</script>
<style>
  .title-article-see{
      font-family: Montserrat;
      font-size: 40px;
      font-weight: 600;
      line-height: 49px;
      letter-spacing: 0em;
      text-align: center;
        overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Número de líneas a mostrar */
  -webkit-box-orient: vertical;
    color:white
    }

    @media (max-width: 600px) {
  .title-article-see{
    font-size: 30px;
  }}
</style>
